<div [ngClass]="this.temaPadrao" class="carrinho-container">
	<mat-list>
		<mat-list-item>
			<h2 class="titulo color-trans-black">Carrinho</h2>
		</mat-list-item>

		<mat-divider></mat-divider>

		<div class="lista-itens-scroll">
			@if (carrinho.getItensCarrinho.length === 0) {
			<mat-list-item class="color-trans-black">
				Carrinho vazio :(
			</mat-list-item>
			}

			@for (item of carrinho.getItensCarrinho; track item.itemDetalhes.idItem) {
			<mat-list-item class="lista-item-carrinho" style="height: 131px;">
				<app-item-carrinho [itemDetalhado]="item" style="width: 100%;display: inline-block;">
				</app-item-carrinho>
				<mat-divider></mat-divider>
			</mat-list-item>
			}
		</div>


		@if (!(carrinho.getItensCarrinho.length === 0)) {
		<mat-list-item class="valor-total">
			<div> <b>Total: {{carrinho.getTotal | currency:'BRL'}}</b></div>
		</mat-list-item>
		}

		<mat-divider></mat-divider>
		<mat-list-item>
			<button class="btn-ver-carrinho" mat-flat-button color="primary" (click)="navegarCarrinho()">Ir para o
				carrinho</button>
		</mat-list-item>
	</mat-list>
</div>
